module.exports = __webpack_public_path__ + "static/media/payment_methods.b1cff80b.png";